export const GET_DIST_POST_QUERY_DATA = "GET_DIST_POST_QUERY_DATA";
export const GET_DIST_POST_QUERY_DATA_SUCCESS =
  "GET_DIST_POST_QUERY_DATA_SUCCESS";
export const GET_DIST_POST_QUERY_DATA_FAILED =
  "GET_DIST_POST_QUERY_DATA_FAILED";
